import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      overflow: "hidden",
      marginTop: 20,
      marginBottom: 90,
    },
    title: {
      marginBottom: 30,
      [theme.breakpoints.up("mobile")]: {
        display: "inline-block",
        textTransform: "uppercase",
      },
    },
    blankView: {
      padding: 25,
      marginBottom: 25,
      textAlign: "center",
      borderRadius: 15,
    },
    addBirthdaysBtn: {
      marginTop: 10,
      [theme.breakpoints.up("mobile")]: {
        marginTop: 25,
      },
      [theme.breakpoints.up("tablet")]: {
        marginTop: 25,
      },
    },
    people: {
      width: "105%",
      paddingBottom: 20,
      marginTop: 20,
      overflow: "scroll",
      whiteSpace: "nowrap",
      [theme.breakpoints.up("mobile")]: {
        width: "100%",
        textAlign: "center",
        overflow: "hidden",
      },
    },
  }),
  { name: "UpcomingDates" },
);
